import axios from 'axios';

const API_URL = 'https://skipperlog.app/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const auth = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  signup: (email, password, name) => api.post('/auth/signup', { email, password, name }),
};

export const passwordReset = {
  request: (email) => api.post('/password-reset/request', { email }),
  reset: (token, newPassword) => api.post('/password-reset/reset', { token, newPassword }),
};

export const bateau = {
  getAll: () => api.get('/bateau'),
  create: (data) => api.post('/bateau', data),
  update: (id, data) => api.put(`/bateau/${id}`, data),
  delete: (id) => api.delete(`/bateau/${id}`),
};

export const checklist = {
  create: (bateauId) => api.post(`/checklist/${bateauId}`),
  getByBateau: (bateauId) => api.get(`/checklist/bateau/${bateauId}`),
  update: (id, items, completed) => api.put(`/checklist/${id}`, { items, completed }),
  delete: (id) => api.delete(`/checklist/${id}`),
};

export const navigation = {
  start: (bateauId, destination, destLatitude, destLongitude, croisiereId) => 
    api.post(`/navigation/start/${bateauId}`, { destination, destLatitude, destLongitude, croisiere_id: croisiereId }),
  stop: (id) => api.put(`/navigation/stop/${id}`),
  update: (id, data) => api.put(`/navigation/${id}`, data),
  getByBateau: (bateauId) => api.get(`/navigation/bateau/${bateauId}`),
  addPosition: (navigationId, data) => api.post(`/navigation/${navigationId}/position`, data),
};

export const croisiere = {
  create: (bateauId, nom, description) => 
    api.post('/croisiere', { bateau_id: bateauId, nom, description }),
  getByBateau: (bateauId) => api.get(`/croisiere/bateau/${bateauId}`),
  getActive: (bateauId) => api.get(`/croisiere/bateau/${bateauId}/active`),
  getDetails: (id) => api.get(`/croisiere/${id}`),
  close: (id) => api.put(`/croisiere/${id}/close`),
  delete: (id) => api.delete(`/croisiere/${id}`),
};

export const logEntry = {
  create: (data) => api.post('/log-entry', data),
  getByNavigation: (navigationId) => api.get(`/log-entry/navigation/${navigationId}`),
  getLastEntry: (navigationId) => api.get(`/log-entry/navigation/${navigationId}/last`),
  update: (id, data) => api.put(`/log-entry/${id}`, data),
  delete: (id) => api.delete(`/log-entry/${id}`),
};

export const meteo = {
  get: (zone) => api.get(`/meteo?zone=${zone}`),
  detectZone: (lat, lng) => api.get(`/meteo/detect?lat=${lat}&lng=${lng}`),
  getZones: () => api.get('/meteo/zones'),
};

export default api;